import React from 'react';

import config from 'configs/app';
import NavigationDesktop from 'ui/snippets/navigation/horizontal/NavigationDesktop';

interface Props {
  isHomePage?: boolean;
}

const NavBar = ({ isHomePage }: Props) => {
  if (config.UI.navigation.layout !== 'horizontal') {
    return null;
  }

  return <NavigationDesktop isHomePage={ isHomePage }/>;
};

export default React.memo(NavBar);
